// @ts-nocheck
// Function to create a TreeWalker for DOM traversal
const walker = (rootNode) => {
    // Custom filter to ignore certain tags and elements with specific attributes
    function ignoreScriptAndStyle(node) {
        return !(
            node.tagName === 'SCRIPT' ||
            node.tagName === 'STYLE' ||
            node.tagName === 'PRE' ||
            node.tagName === 'CODE' ||
            node.tagName === 'SVG' ||
            node.hasAttribute('data-no-translate')
        );
    }

    // Creating a TreeWalker with the custom filter
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
            return ignoreScriptAndStyle(node.parentNode)
                ? NodeFilter.FILTER_ACCEPT
                : NodeFilter.FILTER_SKIP;
        }
    });

    return walker;
};

export default walker;